import { dark } from './dark.mjs';
import { light } from './light.mjs';
import { THEME } from '../utils/constants.mjs';
import { logger } from '../utils/logger.mjs';

const themes = {
    light: {
        title: 'Light',
        name: 'light',
        prefix: 'color',
        scheme: light,
        meta: {
            shade: 'light',
            contrast: 'low',
        },
    },
    dark: {
        title: 'Dark',
        name: 'dark',
        prefix: 'color',
        scheme: dark,
        meta: {
            shade: 'dark',
            contrast: 'low',
        },
    },
    high_contrast_light: {
        title: 'Light high contrast',
        name: 'high_contrast_light',
        prefix: 'color',
        scheme: light,
        meta: {
            shade: 'light',
            contrast: 'high',
        },
    },
    high_contrast_dark: {
        title: 'Dark high contrast',
        name: 'high_contrast_dark',
        prefix: 'color',
        scheme: dark,
        meta: {
            shade: 'dark',
            contrast: 'high',
        },
    },
};
const childThemes = {};
/** Add a custom theme. */
const addCustomTheme = (theme, children, extend) => {
    var _a;
    themes[theme.name] = theme;
    childThemes[theme.name] = [
        ...children,
        ...Array.from(childThemes[extend]).filter((c) => !children.some(({ prefix }) => prefix === c.prefix)),
    ];
    logger.log(`Added theme "${theme.name}"`);
    (_a = window[THEME]) === null || _a === void 0 ? void 0 : _a.updateTheme();
};
/** Attach a child theme to each theme type. */
const addChildTheme = (
/** Prefix each variable. */
prefix, 
/** A record of each theme type with it's corresponding theme. */
children) => {
    var _a;
    for (const [key, scheme] of Object.entries(children)) {
        if (childThemes[key] == null) {
            childThemes[key] = [];
        }
        childThemes[key].push({ prefix, scheme });
    }
    logger.log(`Added child theme "${prefix}"`);
    (_a = window[THEME]) === null || _a === void 0 ? void 0 : _a.updateTheme();
};
const loadTheme = (name) => {
    const trueName = name in themes ? name : 'light';
    return [themes[trueName], childThemes[trueName]];
};

export { addChildTheme, addCustomTheme, childThemes, loadTheme, themes };
